import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_LOCATION_PHOTO_URL } from '../../core.global';

/** Columnas `installation_photo_1/2` de `siac_location`. */
export type LocationPhotoSlot = 1 | 2;

/**
 * Lee y sube las fotos de instalación de una ubicación.
 *
 * Las fotos se piden como Blob porque un `<img src>` directo no enviaría el JWT.
 */
@Injectable({ providedIn: 'root' })
export class LocationPhotoService {
    readonly baseUrl = API_LOCATION_PHOTO_URL;

    constructor(private http: HttpClient) {}

    /** Devuelve `null` cuando la ubicación no tiene foto en esa posición (204). */
    getPhoto(locationId: number, photo: LocationPhotoSlot): Observable<Blob | null> {
        const params = new HttpParams().set('location_id', String(locationId)).set('photo', String(photo));
        return this.http.get(this.baseUrl, { params, responseType: 'blob', observe: 'response' }).pipe(
            map(response => response.status === 204 || !response.body || !response.body.size ? null : response.body)
        );
    }

    uploadPhoto(locationId: number, photo: LocationPhotoSlot, file: File): Observable<any> {
        const params = new HttpParams().set('location_id', String(locationId)).set('photo', String(photo));
        const formData = new FormData();
        formData.append('photo', file);
        return this.http.put(this.baseUrl, formData, { params });
    }
}
